<template>
  <div class="container mb-5">
    <div class="row mb-5 my-md-5">
      <div class="col-sm-6 offset-sm-3">
        <h1 class="text-center">
          {{ $t("listagemOS") }}
        </h1>
      </div>
    </div>
    <ListagemOSFilters :loading="loading" @filter="onFilter" />
  </div>
  <DownloadPdfModal ref="downloadPdfModal" v-bind="pdfProps" />
</template>

<script>
import ListagemOSFilters from './components/ListagemOSFilters.vue';
import { getListagemJasperParams } from './listagemOSService';
import DownloadPdfModal from '@/modules/shared/components/DownloadPdfModal.vue';
export default {
  components: { ListagemOSFilters, DownloadPdfModal },
  data: () => ({
    loading: false,
    pagination: {
      page: 1,
      sort: 'dataHoraServico',
      order: 'desc',
      search: '',
    },
    pdfProps: {
      params: {},
      nomeArquivo: 'Listagem',
    },
  }),
  methods: {
    onFilter(filters) {
      this.updateParams(filters);
      this.downloadPdf();
    },
    updateParams(pagination) {
      this.pagination = { ...this.pagination, ...pagination };
    },
    downloadPdf() {
      this.pdfProps.params = getListagemJasperParams(this.pagination);
      this.$refs.downloadPdfModal.show();
    },

  },
};
</script>
